import { useCallback, useEffect, useState } from 'react'

import { F0Button, F0Box } from '@factorialco/f0-react'
import { Maximize, Minimize } from '@factorialco/f0-react/icons/app'
import { useNodesInitialized, useReactFlow } from '@xyflow/react'

import i18n from 'modules/core/lib/i18n'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { TREE_FIT_VIEW_OPTIONS } from 'modules/job_catalog/components/JobCatalogTree/constants'
import { useTreeContext } from 'modules/job_catalog/components/JobCatalogTree/context'
import { NODE_TYPES, normalizeNodeType } from 'modules/job_catalog/lib/nodesUtils'

const TreeControls = () => {
  const { setNodes } = useTreeContext()
  const { fitView, getNodes, viewportInitialized } = useReactFlow()
  const nodesInitialized = useNodesInitialized()
  const [shouldFitView, setShouldFitView] = useState(false)

  useEffect(() => {
    if (!shouldFitView || !viewportInitialized || !nodesInitialized || getNodes().length === 0) {
      return
    }

    void fitView(TREE_FIT_VIEW_OPTIONS)
    setShouldFitView(false)
  }, [fitView, getNodes, nodesInitialized, shouldFitView, viewportInitialized])

  const onExpandAll = useCallback(() => {
    track(trackingEvents.jobCatalog.expandAllSubmit, {
      event_category: 'Organizations',
    })
    setNodes((currentNodes) =>
      currentNodes.map((node) => ({
        ...node,
        data: {
          ...node.data,
          expanded:
            normalizeNodeType(node.data.type) === NODE_TYPES.LEVEL || node.data.hasLevelChildren
              ? false
              : true,
        },
      }))
    )
    setShouldFitView(true)
  }, [setNodes])

  const onCollapseAll = useCallback(() => {
    track(trackingEvents.jobCatalog.collapseAllSubmit, {
      event_category: 'Organizations',
    })
    setNodes((currentNodes) =>
      currentNodes.map((node) => ({
        ...node,
        data: {
          ...node.data,
          expanded: normalizeNodeType(node.data.type) === NODE_TYPES.ROOT,
        },
      }))
    )
    setShouldFitView(true)
  }, [setNodes])

  return (
    <F0Box display="flex" flexDirection="row" gap="md">
      <F0Button
        icon={Maximize}
        label={i18n.t('job_catalog.job_catalog_tree.zoom_controls.expand_all')}
        variant="neutral"
        size="md"
        onClick={onExpandAll}
      />
      <F0Button
        icon={Minimize}
        label={i18n.t('job_catalog.job_catalog_tree.zoom_controls.collapse_all')}
        variant="neutral"
        size="md"
        onClick={onCollapseAll}
      />
    </F0Box>
  )
}

export default TreeControls
